module.exports = __webpack_public_path__ + "static/media/motion-sensor-9-axis_green.bd57a0e9.svg";